import React, { FC, useRef, useState } from 'react';
import { Select } from 'ts/interfaces/Generic';
import { getFormattedCities } from 'utils/flight/flight';
import DropdownMulti from 'components/ui/DropdownMulti/DropdownMulti';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

interface LocationInputProps {
  value: string;
  onChange: (value: string, label: string) => void;
  placeholder: string;
  isInvalid?: boolean;
  defaultOptions?: Select[][];
}

const LocationInput: FC<LocationInputProps> = ({
  value,
  onChange,
  placeholder,
  isInvalid,
  defaultOptions = [],
}) => {
  const [localOptions, setLocalOptions] = useState<Select[][]>([]);
  const previousController = useRef(new AbortController());

  const handleInputChange = (inputValue: string) => {
    if (inputValue.length < 2) {
      setLocalOptions([]);
      return;
    }

    previousController.current?.abort();
    previousController.current = new AbortController();

    (async () => {
      const data = await getFormattedCities(inputValue, previousController.current);
      setLocalOptions([data]);
    })();
  };

  const onChangeVal = (val: string) => {
    const list = [...(localOptions?.[0] || []), ...defaultOptions.flat()];
    const item = list.find((item) => item.value?.toString().toUpperCase() === val.toUpperCase());

    if (item) {
      onChange(val, item.label);
    }
  };

  return (
    <div className="search-element location">
      <DropdownMulti
        labelValue={value}
        options={localOptions?.[0]?.length > 0 ? localOptions : defaultOptions}
        onChange={(val) => onChangeVal(val as string)}
        onChangeText={handleInputChange}
        movablePlaceholder={placeholder}
        movablePlaceholderIcon={faLocationDot}
        isInvalid={isInvalid}
        scrollOnFocusMobile={true}
      />
    </div>
  );
};

export default LocationInput;
